import React, { useEffect } from "react";
import { Modal, Form, Input, Col, Row, message, Select } from "antd";
import { API_METHODS } from "../../../constants";
import useApi from "../../../hooks/useApi";

function AddCategory(props) {
  const main_categories = [
    {
      id: 1,
      maincategory: "Lab Equipment",
    },
    {
      id: 2,
      maincategory: "Medical Devices",
    },
    {
      id: 3,
      maincategory: "Lab Supplies",
    },
    {
      id: 4,
      maincategory: "Molecular Diagnostics & Genomic Systems",
    },
    {
      id: 5,
      maincategory: "Security Detectors",
    },
  ];

  const [form] = Form.useForm();
  const { visible, close, selectedRecord } = props;
  const [response, request] = useApi(
    "/config/category",
    null,
    API_METHODS.POST
  );
  const [editResponse, editRequest] = useApi(
    `/config/category/${selectedRecord && selectedRecord.id}`,
    null,
    API_METHODS.PUT
  );

  useEffect(() => {
    if (response.data) {
      close(true);
      message.success("Category added successfully.");
    }
  }, [response]);

  useEffect(() => {
    if (editResponse.data) {
      close(true);
      message.success("Category updated successfully.");
    }
  }, [editResponse]);

  useEffect(() => {
    if (selectedRecord) {
      form.setFieldsValue(selectedRecord);
    }
  }, [selectedRecord]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        if (selectedRecord) {
          editRequest(values);
        } else {
          request(values, API_METHODS.POST);
        }
      })
      .catch((e) => {});
  };

  const handleCancel = () => {
    close();
  };

  return (
    <Modal
      title={selectedRecord ? "Update Category" : "Add Category"}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      okText="Save"
    >
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="category"
              label="Category"
              rules={[
                { required: true, message: "Category is required." },
                {
                  max: 200,
                  message: "Category should be maximum of 200 characters.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="main_category_id"
              label="Main Category"
              rules={[
                { required: true, message: "Main Category is required." },
              ]}
            >
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {main_categories?.map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.maincategory}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default AddCategory;
